import React from "react";
import {
  Image,
  View,
  Heading,
  // Button,
  useTheme,
  Grid,
} from "@aws-amplify/ui-react";
// import { styled } from "@mui/material/styles";
// import { useNavigate } from 'react-router-dom';
import grapes from "../assets/images/grapes.png";
// import Paper from "@mui/material/Paper";
import "./Home.css";

// const ItemButton = styled(Paper)(({ theme }) => ({
//     textAlign: "center",
//     backgroundColor: "inherit",
//   }));

export const NoItemsFound = () => {

    const { tokens } = useTheme();
    // const navigate = useNavigate();
    // function handleFormSubmitSuccess() {
    //   navigate('/addproduct')
    // }
    
    return (
      <Grid
        templateColumns={{
          base: "1fr",
          medium: "2fr 4fr 2fr",
          large: "3fr 6fr 3fr",
        }}
        templateRows={{
          base: "repeat(5, 5rem)",
          medium: "repeat(6, 5rem)",
          large: "repeat(5, 5rem)",
        }}
        gap={tokens.space.small}
        backgroundColor="inherit"
      >
        <View
          rowSpan={{ base: 1, medium: 6, large: 6 }}
          backgroundColor="inherit"
          textAlign="left"
        ></View>
        <View
          rowSpan={{ base: 8, medium: 6, large: 6 }}
          backgroundColor="inherit"
          textAlign="center"
          marginLeft={{ base: "1em", medium: "1em", large: "1em" }}
          marginTop={{ base: "1em", medium: "3em", large: "3em" }}
        >
          <Heading
            level={3}
            marginBottom={{ base: "1em", medium: "2em", large: "2em" }}
          >
            Benvenuto nella famiglia Merum!
          </Heading>
          <Image
            src={grapes}
            width={{ base: "100%" }}
            height={{ base: "200px", medium: "250px", large: "250px" }}
            objectFit={{ base: "contain", medium: "contain", large: "contain" }}
            justifyContent={{
              base: "center",
              medium: "space-between",
              large: "space-between",
            }}
            alignItems="center"
            marginLeft={"1rem"}
            marginRight={"1rem"}
            marginTop={{ base: "3rem", medium: "1rem", large: "1rem" }}
          />
        </View>
        <View
          rowSpan={{ base: 1, medium: 6, large: 6 }}
          backgroundColor="inherit"
          textAlign="left"
        ></View>
      </Grid>
    );
  };